export enum AuthState {
  UNKNOWN = 'UNKNOWN',
  AUTHENTICATED = 'AUTHENTICATED',
  NEED_TO_LOGIN = 'NEED_TO_LOGIN',
  LOGIN_IN_PROGRESS = 'LOGIN_IN_PROGRESS'
}
